import { Component, Input } from "@angular/core";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-shimmer-loader",
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="shimmer-container" [style.height]="height" [style.width]="width" [style.border-radius]="borderRadius">
      <div class="shimmer-effect"></div>
    </div>
  `,
  styles: [`
    .shimmer-container {
      position: relative;
      overflow: hidden;
      background: #e1e4e8;
    }

    .shimmer-effect {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.4) 50%,
        rgba(255, 255, 255, 0) 100%
      );
      animation: shimmer 1.5s infinite;
    }

    @keyframes shimmer {
      0% { transform: translateX(-100%); }
      100% { transform: translateX(100%); }
    }
  `]
})
export class ShimmerLoaderComponent {
  @Input() height = "20px";
  @Input() width = "100%";
  @Input() borderRadius = "4px";
}
